import * as React from "react";
import Layout from "./Layout";
import Results from "./Results";
import { Box, Container, Link, Typography } from "@mui/material";

const RamzovaPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Od obecního úřadu v Bělé mírný seběh až do Jeseníku
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    4. segment - září
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/25485327"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                    <li>
                        <Link href={"https://www.relive.cc/view/vPv4MAZzX3O"}>
                            Video ukázka
                        </Link>
                    </li>
                </ul>
                <Typography gutterBottom>
                    V průběhu celého září máme pro Vás připravenou trasu z Bělé
                    pod Pradědem až do Jeseníku. Ano, obec Bělá je dlouhá a má
                    na svém katastru připravenou cyklostezku. Čeká nás tedy
                    mírný, sedm kilometrů dlouhý seběh po cyklotrase, tedy
                    pevnějších cestách, než poslední dva segmenty v červenci a
                    srpnu. Může to být Vaše jediná účast, nebo již čtvrtý příděl
                    bodů do celkového seriálu. To necháme na Vás, rozhodně si to
                    můžete zkusit kterýkoliv den v měsíci. Jediným povoleným
                    dopingem jsou dobré povětrnostní podmínky, které Vám v
                    průběhu závodu budou tlačit do zad.
                </Typography>

                <Box
                    component={"ul"}
                    sx={{ marginTop: (theme) => theme.spacing(2) }}
                >
                    <li>
                        START - opět startujeme u obecního úřadu - tentokrát
                        Bělá pod Pradědem. Prostoru k rozcvičení a rozehřátí je
                        v okolí hodně. Startuje se na parkovišti vedle obecního
                        úřadu a běží se DOPRAVA na most přes řeku Bělou.
                        Nebojte, čas trasy se Vám zaeviduje v momentě, kdy
                        budete vbíhat na most.
                    </li>
                    <li>
                        Průběh trasy - po přeběhnutí mostu Vás brzy čeká
                        křižovatka, kde poběžíte doleva. ZDE již naběhnete na
                        cyklotrasu s číslem 6210 a směrově běžíte již k
                        Jeseníku. Úzká cesta Vás čeká celý kilometr, následně
                        sbíháte na křižovatku, kde opět pokračujete po
                        cyklotrase 6210 - tedy odbočíte na křižovatce VPRAVO.
                        Následně budete využívat zadních cest obce a po ní
                        vedené cyklotrasy. Je to pro Vás nový pohled na obec
                        Bělá pod Pradědem? Těsně za polovinou trasy Vás čeká
                        přeběh hlavní cesty. Ten proběhne tak, že z vedlejší
                        cesty za řekou naběhnete doleva a křižně zvládnete
                        přeběhnout most i cestu zároveň. Budete tak na druhé
                        straně řeky i hlavní cesty a stále na cyklotrase 6210
                        směřující do Jeseníku. POZOR - blíží se nejsložitější
                        část trati. Po vyběhnutí mírného kopce a průběhu přes
                        lom a váhu automobilů u lomu sbíháte pod Benzínovou
                        pumpou a zde je úzká jen travnatá zkratka na hlavní
                        cestu. Tak tudy! Dostanete se na hlavní cestu a máte
                        velký rozhled dolů i nahoru vůči automobilové dopravě na
                        hlavní cestě. Tu přeběhněte křižně za řeku na zadní
                        cestu. Tedy v době kdy Vám to bude vyhovovat vůči
                        dopravě. Buďte opatrní! Po zadní cestě už opět
                        pokračujete po cyklotrase 6210. Přibližně 6 km už budete
                        mít za sebou a ještě poslední kilometr před sebou, kdy
                        budete přibíhat po ulici Slunná a křižovat cestu
                        Rejvízká, zde opět pozor, přibíháte z vedlejší a
                        směřujte na protější chodník, po kterém poběžíte dál po
                        chodníku až k ZŠ Jeseník, Nábřežní a dále po chodníku i
                        kolem vysokého paneláku (stále rovně). Poté se už
                        směřujte na cestu a dále pokračujete podél řeky až na
                        křížící ulici Karla Čapka.
                    </li>
                    <li>
                        CÍL: Trasa v září má specifický doběh hodný filmu Rocky
                        Balboa. Ano, 250 m před cílem se na Nábřežní ulici
                        dostanete ke křižování s ulicí Karla Čapka, stejně jako
                        cyklotrasa. ZDE odbočíte DOPRAVA a běžíte nahoru k
                        IPOSU. Již před křižovatkou, kde cyklotrasa míří do
                        Smetanových sadů doporučujeme naběhnout tak, aby jste
                        dále pokračovali rovně po chodníku ke schodišti do
                        vstupu - budovy IPOSU. Cíl je v místě posledních schodů
                        nad parkovištěm
                    </li>
                </Box>
                <Results segmentId={"3-4-25485327"} />
            </Container>
        </Layout>
    );
};

export default RamzovaPage;
